module.exports = __webpack_public_path__ + "img/partner_6.0df14dcd.png";